module.exports = __webpack_public_path__ + "static/media/logo_cropped.ee4b2139.png";